"use client";
import { HeaderLinkButton } from "@/components/header/headerLinkButton";
import NextLink from "next/link";
import { usePathname } from "next/navigation";

const menus = [
	{ name: "Home", href: "/" },
	{ name: "Events", href: "/events" },
	{ name: "Teams", href: "/teams" },
	{ name: "Partners", href: "/partners" },
];

export const Header = () => {
	const pathname = usePathname();
	const isSuzuka2024 = pathname?.endsWith("events/suzuka2024/detail");
	const isSuzuka2025 = pathname?.endsWith("events/suzuka2025/detail");
	const isWakayama2024 = pathname?.endsWith("events/wakayama2024/detail");
	const is2024techfes =
		pathname?.endsWith("events/2024techfes/detail") ||
		pathname?.endsWith("events/2024techfes/lecture") ||
		pathname?.endsWith("events/2024techfes/hackathon");

	const bgColor = isSuzuka2024
		? "bg-suzuka2024hot"
		: isSuzuka2025
			? "bg-suzuka2025purple"
			: is2024techfes
				? "bg-techfes2024"
				: isWakayama2024
					? "bg-wakayama2024"
					: "bg-sky-100";

	const baseWhiteFontColor = isSuzuka2024
		? "text-suzuka2024naby"
		: isSuzuka2025
			? "text-white"
			: is2024techfes
				? "text-techfes2024"
				: isWakayama2024
					? "text-wakayama2024"
					: "text-sky-600";

	const baseBlackFontColor = isSuzuka2024
		? "text-suzuka2024naby"
		: isSuzuka2025
			? "text-white"
			: isWakayama2024
				? "text-wakayama2024"
				: is2024techfes
					? "text-white"
					: "text-black";

	return (
		<header className={`h-100 ${bgColor} shadow relative z-50`}>
			<nav
				className="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8"
				aria-label="Global"
			>
				<NextLink
					href={"/"}
					className={`font-bold text-2xl ${baseWhiteFontColor}`}
				>
					Startup Hub Kosen
				</NextLink>

				<div className="hidden lg:flex lg:flex-1 lg:justify-end gap-5 items-center">
					{menus.map((menu) => (
						<NextLink
							key={menu.name}
							href={menu.href}
							className={`text-md font-semibold leading-6 ${baseBlackFontColor}`}
						>
							{menu.name}
						</NextLink>
					))}
					<HeaderLinkButton
						href={"https://prossell.jp/contact"}
						text={"企業の方へ"}
					/>
					<HeaderLinkButton
						href={"https://prossell.jp/contact"}
						text={"学校の方へ"}
					/>
				</div>
			</nav>
		</header>
	);
};
